module.exports = __webpack_public_path__ + "img/c4e3fc1.jpg";